import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// GET wishlist
export const REQUEST_WISHLIST = 'REQUEST_WISHLIST';
export const REQUEST_WISHLIST_SUCCESS = 'REQUEST_WISHLIST_SUCCESS';
export const REQUEST_WISHLIST_FAILURE = 'REQUEST_WISHLIST_FAILURE';

// GET wishlist item
export const REQUEST_WISHLIST_ITEM = 'REQUEST_WISHLIST_ITEM';
export const REQUEST_WISHLIST_ITEM_SUCCESS = 'REQUEST_WISHLIST_ITEM_SUCCESS';
export const REQUEST_WISHLIST_ITEM_FAILURE = 'REQUEST_WISHLIST_ITEM_FAILURE';

// POST wishlist
export const REQUEST_POST_WISHLIST = 'REQUEST_POST_WISHLIST';
export const REQUEST_POST_WISHLIST_SUCCESS = 'REQUEST_POST_WISHLIST_SUCCESS';
export const REQUEST_POST_WISHLIST_FAILURE = 'REQUEST_POST_WISHLIST_FAILURE';

// DELETE wishlist
export const REQUEST_DELETE_WISHLIST = 'REQUEST_DELETE_WISHLIST';
export const REQUEST_DELETE_WISHLIST_SUCCESS = 'REQUEST_DELETE_WISHLIST_SUCCESS';
export const REQUEST_DELETE_WISHLIST_FAILURE = 'REQUEST_DELETE_WISHLIST_FAILURE';

// UPDATE wishlist
export const REQUEST_UPDATE_WISHLIST = 'REQUEST_UPDATE_WISHLIST';
export const REQUEST_UPDATE_WISHLIST_SUCCESS = 'REQUEST_UPDATE_WISHLIST_SUCCESS';
export const REQUEST_UPDATE_WISHLIST_FAILURE = 'REQUEST_UPDATE_WISHLIST_FAILURE';


// Filter
export const ACTION_CHANGE_FILTER = 'ACTION_CHANGE_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER_WISHLIST';

const defaultState = {
    wishlist: [],
    fetchingWishlist: false,
    failedFetchingWishlist: false,
    isLoadMore: false,
    isPostingWishlist: false,
    failedPostingWishlist: false,
    wishlistItem: null,
    fetchingWishlistItem: false,
    failedFetchingWishlistItem: false,
    isDeletingWishlist: false,
    failedDeletingWishlist: false,
    isUpdatingWishlist: false,
    failedUpdatingWishlist: false,
};

const reducer = createReducer(defaultState, {
    [REQUEST_WISHLIST]: (state) => ({
        ...state,
        fetchingWishlist: true,
        failedFetchingWishlist: false,
    }),
    [REQUEST_WISHLIST_SUCCESS]: (state, action) => {
        const newItems = action.payload?.data?.items || action.payload?.items || [];
        let finalItems = newItems;

        if (state.isLoadMore) {
            const currentItems = state.wishlist?.data?.items || state.wishlist?.items || [];
            finalItems = [...currentItems, ...newItems];
        }

        return {
            ...state,
            wishlist: {
                ...action.payload,
                data: {
                    ...(action.payload?.data || {}),
                    items: finalItems,
                },
                // Ensure items is also updated at root if that's the structure
                items: finalItems,
            },
            fetchingWishlist: false,
            failedFetchingWishlist: false,
            isLoadMore: false,
        };
    },
    [REQUEST_WISHLIST_FAILURE]: (state) => ({
        ...state,
        fetchingWishlist: false,
        failedFetchingWishlist: true,
        isLoadMore: false,
    }),
    [REQUEST_WISHLIST_ITEM]: (state) => ({
        ...state,
        fetchingWishlistItem: true,
        failedFetchingWishlistItem: false,
    }),
    [REQUEST_WISHLIST_ITEM_SUCCESS]: (state, action) => ({
        ...state,
        wishlistItem: action.payload,
        fetchingWishlistItem: false,
        failedFetchingWishlistItem: false,
    }),
    [REQUEST_WISHLIST_ITEM_FAILURE]: (state) => ({
        ...state,
        fetchingWishlistItem: false,
        failedFetchingWishlistItem: true,
    }),
    [REQUEST_POST_WISHLIST]: (state) => ({
        ...state,
        isPostingWishlist: true,
        failedPostingWishlist: false,
    }),
    [REQUEST_POST_WISHLIST_SUCCESS]: (state) => ({
        ...state,
        isPostingWishlist: false,
        failedPostingWishlist: false,
    }),
    [REQUEST_POST_WISHLIST_FAILURE]: (state) => ({
        ...state,
        isPostingWishlist: false,
        failedPostingWishlist: true,
    }),
    [REQUEST_DELETE_WISHLIST]: (state) => ({
        ...state,
        isDeletingWishlist: true,
        failedDeletingWishlist: false,
    }),
    [REQUEST_DELETE_WISHLIST_SUCCESS]: (state) => ({
        ...state,
        isDeletingWishlist: false,
        failedDeletingWishlist: false,
    }),
    [REQUEST_DELETE_WISHLIST_FAILURE]: (state) => ({
        ...state,
        isDeletingWishlist: false,
        failedDeletingWishlist: true,
    }),
    [REQUEST_UPDATE_WISHLIST]: (state) => ({
        ...state,
        isUpdatingWishlist: true,
        failedUpdatingWishlist: false,
    }),
    [REQUEST_UPDATE_WISHLIST_SUCCESS]: (state) => ({
        ...state,
        isUpdatingWishlist: false,
        failedUpdatingWishlist: false,
    }),
    [REQUEST_UPDATE_WISHLIST_FAILURE]: (state) => ({
        ...state,
        isUpdatingWishlist: false,
        failedUpdatingWishlist: true,
    }),
    // Filter
    [ACTION_CHANGE_FILTER]: (state, action) => ({
        ...state,
        wishlistFilter: action.payload,
    }),
    [UPDATE_FILTER]: (state, action) => ({
        ...state,
        wishlistFilter: action.payload,
    }),
});

export default reducer;
export const namespace = 'wishlist';

export const actionUpdateFilter = (filters) => ({
    type: UPDATE_FILTER,
    payload: filters,
});

export const getWishlists = (payload) => async (dispatch, getState) => {
    return await callAPI({
        method: 'get',
        apiPath: '/wishlist',
        actionTypes: [REQUEST_WISHLIST, REQUEST_WISHLIST_SUCCESS, REQUEST_WISHLIST_FAILURE],
        variables: {
            ...payload,
        },
        dispatch,
        getState,
    });
};

export const getWishlistItem = (id) => async (dispatch, getState) => {
    return await callAPI({
        method: 'get',
        apiPath: `/wishlist/${id}`,
        actionTypes: [REQUEST_WISHLIST_ITEM, REQUEST_WISHLIST_ITEM_SUCCESS, REQUEST_WISHLIST_ITEM_FAILURE],
        dispatch,
        getState,
    });
};

export const postWishlist = (payload) => async (dispatch, getState) => {
    return await callAPI({
        method: 'post',
        apiPath: '/wishlist/create',
        actionTypes: [REQUEST_POST_WISHLIST, REQUEST_POST_WISHLIST_SUCCESS, REQUEST_POST_WISHLIST_FAILURE],
        variables: {
            ...payload,
        },
        dispatch,
        getState,
    });
};

export const deleteWishlist = (id) => async (dispatch, getState) => {
    return await callAPI({
        method: 'delete',
        apiPath: `/wishlist/${id}`,
        actionTypes: [REQUEST_DELETE_WISHLIST, REQUEST_DELETE_WISHLIST_SUCCESS, REQUEST_DELETE_WISHLIST_FAILURE],
        dispatch,
        getState,
    });
};

export const updateWishlist = (id, payload) => async (dispatch, getState) => {
    return await callAPI({
        method: 'put',
        apiPath: `/wishlist/${id}`,
        actionTypes: [REQUEST_UPDATE_WISHLIST, REQUEST_UPDATE_WISHLIST_SUCCESS, REQUEST_UPDATE_WISHLIST_FAILURE],
        variables: {
            ...payload,
        },
        dispatch,
        getState,
    });
};

